<ng-container *transloco="let t;">
    <div class="select-template-head p-0" [ngClass]="{'crm-section': view === 'crm'}">

        <div class="row">
            <div class="col-md-8 col-lg-8">
                <div class="d-flex align-content-center justify-content-between w-100">
                    <div class="input-group no-box-shadow input-group-merge">
                        <div class="input-group-prepend">
                            <span class="input-group-text border-0"><i data-feather="search"></i></span>
                        </div>
                        <input type="text" class="form-control border-0"
                            [placeholder]="t('Search template field placeholder - (Select template modal) - Search templates')"
                            (keydown.enter)="getTemplates(1,$event.target.value)" />
                    </div>
                </div>
            </div>
            <div class="m-0 d-flex align-items-center justify-content-end header-section-btn col-sm-12 col-md-4 col-lg-4">
                <div class="p-0">
                    <div class="list-group-item mb-0 pb-0 pt-0 px-0">
                        <div class="form-group mb-0">
                            <ng-select [items]="documentTypes | async" bindLabel="document_type" bindValue="id"
                                [(ngModel)]="selectedDocumentType" [readonly]="false" [searchable]="false"
                                [placeholder]="t('Filter document type dropdown placeholder - (Select template modal) - Please select type')"
                                [clearable]="false" (change)="getTemplates(1,'')">
                            </ng-select>
                        </div>
                    </div>
                </div>
                <!-- Dont Remove This (Mubashir) will work on the logout section design -->
                <div class="p-0 logout-btn-crm">
                    <button type="button" rippleEffect aria-label="Logout" class="cursor-pointer btn py-0 px-50" (click)="logoutCrmUser()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-power" width="30"
                            height="30" viewBox="0 0 24 24" stroke-width="1.5" stroke="#FF2825" fill="none"
                            stroke-linecap="round" stroke-linejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M7 6a7.75 7.75 0 1 0 10 0" />
                            <path d="M12 4l0 8" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>

    </div>
    @if(view === 'crm'){
    <div class="col-lg-12 p-0 row mx-1">
        <div class="template-upload-wrapper col-lg-12 mb-2">
            <div class="card-header">
                <div class="d-flex align-items-center">
                    <h4 class="card-title">{{ t('Upload file box title - (Select template modal) - Upload a file') }}
                    </h4>
                </div>
            </div>
            <div class="card-body" (fileDropped)="onFileDropped($event)" appDropFiles>
                <input class="fileDrop" type="file" #uploadFileInput (change)="onFileDropped($event)"
                    [accept]="acceptableFiles" />
                <div class="py-5 text-center font-medium-5 text-uppercase file-drop-zone">
                    {{ t('Upload file box sub title - (Select template modal) - Drop files here or click to upload') }}
                </div>
            </div>
        </div>
    </div>
    }
    <app-skeleton *ngIf="loading" [section]="'select-template'" [loop]="0"></app-skeleton>
    <div class="select-template-box mt-2 pt-50" *ngIf="!loading" [ngClass]="{'opacity-50 pointer-none': createingDocument}">
        <div class="col-lg-12 p-0 row m-0">
            <div class="col-md-6 col-lg-6 col-sm-6 col-xs-12 col-xl-4 mb-2 position-relative"
                *ngFor="let template of templateListing" (click)="goToSendDocument(template,template.template.id)">
                <div class="card mb-0">
                    <div class="row">
                        <div class="col-md-4 template-thumbnail">
                            <ng-container *ngIf="template.template.thumbnail; else noThumbnail">
                                <img class="card-img card-img-left" [src]="template.template.id | thumbnail: 'templates' "
                                    alt="Thumbnail">
                            </ng-container>
                            <ng-template #noThumbnail>
                                <div class="no-thumbnail"></div>
                            </ng-template>
                        </div>
                        <div class="col-md-8 ps-0 template-info">
                            <div class="card-body">
                                <h5 class="card-title font-medium-1">{{template.template.name}}</h5>
                                <p class="template-description font-small-3 mb-0">{{ template?.template_settings?.description }}</p>
                                <p class="card-text templatesThumbnail-footer-text">
                                    <small>{{(template.template_details?.document_type_id | getDocumentType) | async}}</small>
                                </p>
                            </div>
                        </div>

                        <div class="select-template-loader">
                            <div class="select-template-inner">
                                <label>{{ t('Select template modal loading text - (Select template modal) - Please wait') }}</label>
                                <ngb-progressbar type="primary" [value]="25"></ngb-progressbar>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="template-pagination-row">
        @if(pagination){
            <ngb-pagination (pageChange)="getTemplates($event)" [collectionSize]="pagination.total" [(page)]="page"
                [maxSize]="3" aria-label="Default pagination">
                <ng-template ngbPaginationPrevious>
                    <span [data-feather]="'chevron-left'" [size]="18" [class]="'fw-bolder'"></span>
                </ng-template>
                <ng-template ngbPaginationNext>
                    <span [data-feather]="'chevron-right'" [size]="18" [class]="'fw-bolder'"></span>
                </ng-template>
            </ngb-pagination>   
        }
    </div>
</ng-container>